import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LoaderService {
  private load: BehaviorSubject<string>;

  constructor() {
    this.load = new BehaviorSubject<string>('');
  }

  getProgress(): Observable<string> {
    return this.load.asObservable();
  }

  setProgress(value: string): void {
    this.load.next(value);
  }
}
